import application from './application';
import awdLogin from './AWDLogin';
import policyHistory from './policyHistory';
import policyRecord from './policyRecord';
import workQueue from './workQueue';

export default {
  awdLogin,
  workQueue,
  policyHistory,
  policyRecord,
  application,
};
